export const milestoneTaskItemStyles = {
     taskItem: {
          gap: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginLeft: "16px",
          marginBottom: "8px",
     },
     completionDate: {
          color: "#11834A",
          backgroundColor: "#EFFBF5",
          borderRadius: "20px",
          padding: "4px 8px",
          display: "flex",
          alignItems: "center",
     },
     divisionUpdateDate: {
          color: "white",
          backgroundColor: "#5b7282",
          borderRadius: "20px",
          padding: "4px 8px",
          display: "flex",
          alignItems: "center",
     },
     dueDate: {
          backgroundColor: "#E7ECF0",
          borderRadius: "20px",
          padding: "4px 8px",
          display: "flex",
          alignItems: "center",
     },
     checkbox: {
          padding: "8px",
          alignSelf: "flex-start",
          color: "#5B7282",
          "&.Mui-disabled": {
               color: "#5B7282",
          },
     },
}; 